module.exports = __webpack_public_path__ + "static/media/bulldog.a8816cbe.png";